import { useState, useEffect, useCallback } from 'react';
import { fetchAllHistoryPages } from '../utils/apiHelpers';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Fetches saved Update Title runs (request_type=update_title). Shared by the Manage
// page's merged grid, mirroring useListingScoreHistory / useDealTagHistory.
const useTitleUpdateHistory = (token) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchHistory = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    setError(null);
    try {
      const response = await fetchAllHistoryPages(
        `${API_BASE_URL}/auth/user_history?request_type=update_title`,
        token
      );
      const rows = response.data?.data;
      setProjects(Array.isArray(rows) ? rows : []);
    } catch (err) {
      setError(err.message || 'Failed to load title updates');
      setProjects([]);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { fetchHistory(); }, [fetchHistory]);

  return { loading, error, projects };
};

export default useTitleUpdateHistory;
